import type { Row } from "@tanstack/react-table"
import { add, Dinero } from "dinero.js"

import { isDinero } from "../../../modules/currency/currencyLib"

/**
 * Sums a Dinero-valued column (as produced by `columnFactory.moneyColumn`) across the rows of a table group.
 * Returns undefined when no row in the group has an amount, so the aggregated cell can render empty
 * just like a regular cell without a value.
 */
export function sumDineroColumn<TData extends Record<string, unknown>>(
    columnId: string,
    _leafRows: Array<Row<TData>>,
    childRows: Array<Row<TData>>,
): Dinero<number> | undefined {
    const amounts = childRows.map((row) => row.getValue(columnId)).filter(isDinero)

    if (!amounts.length) return undefined

    return amounts.reduce((sum, next) => add(sum, next))
}
